// @flow
// $FlowFixMe
import { css } from 'styled-components'

const sizes = {
  giant: 1280,
  desktop: 1024,
  tabletLarge: 760,
  tablet: 440,
  phone: 300
}

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16
  // $FlowFixMe
  accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})



// WEBPACK FOOTER //
// ./src/theme/style-utils.js